import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetContactTemplateBasicDetailsQueryVariables = Types.Exact<{
   [key: string]: never
}>

export type GetContactTemplateBasicDetailsQuery = {
   __typename?: 'Query'
   getUserAppConfig: {
      __typename?: 'UserAppConfig'
      contactTemplate: {
         __typename?: 'ContactTemplate'
         contactTemplateId: string
         name: string
      }
   }
}

export const GetContactTemplateBasicDetailsDocument = gql`
   query getContactTemplateBasicDetails {
      getUserAppConfig {
         contactTemplate {
            contactTemplateId
            name
         }
      }
   }
`
export type GetContactTemplateBasicDetailsQueryResult = Apollo.QueryResult<
   GetContactTemplateBasicDetailsQuery,
   GetContactTemplateBasicDetailsQueryVariables
>
